import type { ReactElement } from 'react';

import type { CatalogItem } from '@/lib/quality-catalogs';

import { Select } from './Select';

// Selector de un catálogo de calidad (tipo de documento, proceso): "Todos" o un ítem.
// Lo usan los filtros de Estudio de tiempos y de la Lista Maestra.

export function CatalogSelect(props: {
  label: string;
  value: string | null;
  items: CatalogItem[] | undefined;
  onChange: (id: string | null) => void;
  /** Texto de la opción sin filtro ("Todos" por defecto; "Todas" para norma y cláusula). */
  allLabel?: string;
  /** Marca de un ítem desactivado, en el género del catálogo (" (inactivo)" por defecto). */
  inactiveSuffix?: string;
  /** El catálogo no se pudo cargar: se dice y se ofrece reintentar (UX-ERR-01). */
  failed?: boolean;
  onRetry?: () => void;
}): ReactElement {
  if (props.failed === true) {
    return (
      <div className="fld">
        <span>{props.label}</span>
        <div className="fld-error" role="alert">
          No se pudo cargar {props.label}.
          {props.onRetry && (
            <button
              type="button"
              className="btn mut sm"
              onClick={props.onRetry}
              aria-label={`Reintentar ${props.label}`}
            >
              Reintentar
            </button>
          )}
        </div>
      </div>
    );
  }
  // Un valor de la URL que el catálogo ya no lista se muestra igual, para no ocultarlo.
  const known = props.items?.some((i) => i.id === props.value) ?? false;
  const options = [
    { value: '', label: props.allLabel ?? 'Todos' },
    ...(props.value !== null && !known ? [{ value: props.value, label: 'Filtro actual' }] : []),
    ...(props.items ?? []).map((i) => ({
      value: i.id,
      label: i.isActive ? i.name : `${i.name}${props.inactiveSuffix ?? ' (inactivo)'}`,
    })),
  ];
  return (
    <label className="fld">
      <span>{props.label}</span>
      <Select
        value={props.value ?? ''}
        options={options}
        disabled={props.items === undefined}
        onChange={(v) => props.onChange(v === '' ? null : v)}
      />
    </label>
  );
}
